'use client';

import React from 'react';

import { Verification } from '@depop/web-thrift-ui/Icons/Verification';
import { Body } from '@depop/web-thrift-ui/Typography';
import { AVATAR_SIZE } from '@depop/web-ui-kit/Avatar';

import styles from './styles.module.css';

import { AvatarWithLink } from '@/components/AvatarWithLink';
import { ExtendedLink } from '@/components/ExtendedLink';
import { Feedback } from '@/components/Feedback';

type Props = {
  seller: {
    id: number;
    username: string;
    initials: string;
    verified?: boolean;
    avatarUrl?: string;
  };
  shopHref: string;
  avatarAlt: string;
  feedbackRating?: number;
  feedbackCount?: number;
  children?: React.ReactNode;
};

function SellerIdentityRow({
  seller,
  shopHref,
  avatarAlt,
  feedbackRating,
  feedbackCount,
  children,
}: Props) {
  const hasFeedback = Boolean(feedbackCount && feedbackCount > 0);

  return (
    <div className={styles.row}>
      <AvatarWithLink
        src={seller.avatarUrl}
        href={shopHref}
        ariaLabel={avatarAlt}
        initials={seller.initials}
        alt={avatarAlt}
        size={AVATAR_SIZE.SMALL}
        className={styles.avatar}
      />
      <div className={styles.info}>
        <div className={styles.nameRow}>
          <ExtendedLink
            href="/[username]"
            as={shopHref}
            className={styles.username}
          >
            <Body variant="sm-bold" as="span">
              {seller.username}
            </Body>
          </ExtendedLink>
          {seller.verified && (
            <span className={styles.verifiedBadge}>
              <Verification size="sm" />
            </span>
          )}
        </div>
        {children}
        {hasFeedback && (
          <Feedback
            rating={feedbackRating || 0}
            count={feedbackCount || 0}
            sellerUsername={seller.username}
            sellerId={seller.id}
          />
        )}
      </div>
    </div>
  );
}

export { SellerIdentityRow };
